import {API, graphqlOperation} from "aws-amplify";
import {ReceiveAnnouncementSubscription} from "../API";
import {ZenObservable} from "zen-observable-ts/lib/types";
import {receiveAnnouncement} from "./subscriptions";
import {pushAnnouncement as pushAnnouncementMutation} from "./mutations";
import {MapAnnouncement} from "../models/Announcement/MapAnnouncement";
import {deserializeMapAnnouncement} from "../models/Announcement/MapAnnouncementType";

type ReceiveAnnouncementSubscriptionData = {
    value: { data: ReceiveAnnouncementSubscription };
};

export async function subscribeAnnouncement(onReceiveAnnouncement: (announcement: MapAnnouncement) => void): Promise<ZenObservable.Subscription> {
    const receive_announcement = await API.graphql({
        query: receiveAnnouncement
    });

    if (!("subscribe" in receive_announcement)) {
        throw new Error('subscribeAnnouncement failed');
    }

    return receive_announcement.subscribe({
        next: (data: ReceiveAnnouncementSubscriptionData) => {
            const a = data.value.data.receiveAnnouncement;
            if (a) {
                onReceiveAnnouncement(deserializeMapAnnouncement(a.mapId, a.type, a.value));
            }
        }
    });
}

export async function pushAnnouncement(announcement: MapAnnouncement) {
    await API.graphql(graphqlOperation(pushAnnouncementMutation, {
        mapId: announcement.MapId,
        type: announcement.Type,
        value: announcement.serializeValue()
    }));

}
